module.exports = __webpack_public_path__ + "img/vip2.f1564e32.png";